/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {IComponentOptions, ITimeoutService} from 'angular';
import ILogService = angular.ILogService;

declare let require: any;
declare let angular: any;
require('./dv-geoadmin-map.scss');

export class GeoAdminMapComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        lon: '=',
        lat: '=',
        onEdit: '&',
        readonly: '<'
    };
    template = require('./dv-geoadmin-map.html');
    controller = DvGeoAdminMapController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvGeoAdminMapController {

    static $inject = ['$log', '$window', '$timeout'];

    positions: Array<any> = [];

    lon: string;
    lat: string;

    map: any;
    view: any;
    point: any;
    onEdit: (paramObj: any) => void;
    readonly: boolean;

    constructor(private $log: ILogService, private $window: any, private $timeout: ITimeoutService) {
    }

    $onInit() {

        // we need a timout here to load map after the modal!
        this.$timeout(() => {
            this.initMyMap();

            if (this.lon && this.lat) {

                this.addMarkerOnPosition(this.lon, this.lat);
            }
        });
    }

    private addMarkerOnPosition(lon: string, lat: string) {

        // umrechnen in lv95 Schweizer-Koordinaten
        // @ts-ignore
        let swissCoordLV95 = ol.proj.transform([lon, lat], 'EPSG:4326', 'EPSG:2056');

        // Zoom on the position
        this.map.getView().setCenter(swissCoordLV95);
        this.map.getView().setResolution(10);

        this.createMarkerLayerWithPosition(swissCoordLV95);
    }

    private createMarkerLayerWithPosition(swissCoordLV95: any): void {
        // @ts-ignore
        this.point = new ol.geom.Point(swissCoordLV95);

        // Create the layer with the icon
        // @ts-ignore
        let vectorLayer = new ol.layer.Vector({
            // @ts-ignore
            source: new ol.source.Vector({
                // @ts-ignore
                features: [new ol.Feature({
                    // @ts-ignore
                    geometry: this.point
                })]
            }),
            // @ts-ignore
            style: new ol.style.Style({
                // @ts-ignore
                image: new ol.style.Icon({
                    anchor: [0.5, 0.5],
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'fraction',
                    // tslint:disable-next-line:max-line-length
                    src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAVCAYAAABPPm7SAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH5AYFCSYdVpYi1AAAASZJREFUOMudkzFrAkEQhb/zYmNlYXtgYSkkkN60/p6ktkwq0/sL0til8AeYKhBEQQ6s06SyCFiIwZfCMWyGvctdHgwcM++9nZ3ZAwdBX3AvWAv2FmvBg6BPDIJEkAqeTaCC2BsnFSShQVMwLxH6eBE0Q4NZDfE5ZnBq/RJ4Ay7czd6BpX1fAZmrfwHXCB4j7k+CNOgwtZznjRFsXPJD0A6HZENuWy3kbhAcXHJBAQQLxz00gKPjpRTD144IVs71U9CNnN61WshdIbiLDCcXDALxjeU87xZBJtj+4x1sBVkjOe17Qn1MTPvTZl7j9Dy2op5gV0G8E/SK9jyqYDAqvZhgWiKe/jkZQSfyZM9PvFNpvIJhxGBYa0eC8a+/ri4ELcGrRauI9w0wDGhbq0LnFwAAAABJRU5ErkJggg=='
                })
            })
        });
        this.map.addLayer(vectorLayer);
    }

    private initMyMap() {

        // @ts-ignore
        let mousePositionControl = new ol.control.MousePosition({
            // @ts-ignore
            coordinateFormat: ol.coordinate.createStringXY(0),
            projection: 'EPSG:2056',
            // comment the following two lines to have the mouse position
            // be placed within the map.
            className: 'custom-mouse-position',
            target: document.getElementById('mouse-position'),
            undefinedHTML: '&nbsp;'
        });

        // @ts-ignore
        this.view = new ol.View({
            // projection: projection,

            // Define the default resolution
            // 10 means that one pixel is 10m width and height
            // List of resolution of the WMTS layers:
            // 650, 500, 250, 100, 50, 20, 10, 5, 2.5, 2, 1, 0.5, 0.25, 0.1
            resolution: 500,

            // Define a coordinate CH1903+ (EPSG:2056) for the center of the view
            center: [2660000, 1190000]
        });

        // @ts-ignore
        this.map = new ga.Map({
            // @ts-ignore
            controls: ol.control.defaults({
                attributionOptions: /** @type {olx.control.AttributionOptions} */ ({
                    collapsible: false
                })
            }).extend([mousePositionControl]),

            // Define the div where the map is placed
            target: 'map',

            // Create a view
            // @ts-ignore
            view: this.view
        });

        // Create a background layer
        // @ts-ignore
        let lyr1 = ga.layer.create('ch.swisstopo.pixelkarte-farbe');

        // Add the background layer in the map
        this.map.addLayer(lyr1);

        if (!this.readonly) {
            this.map.on('singleclick', (evt: any) => {

                let swissCoordinate = evt.coordinate;

                if (!this.point) {
                    this.createMarkerLayerWithPosition(swissCoordinate);
                } else {
                    // if we have already a position, just change point
                    this.point.setCoordinates(swissCoordinate);
                }

                // @ts-ignore
                let gpsCoord = ol.proj.transform(swissCoordinate, 'EPSG:2056', 'EPSG:4326');
                this.positionChanged(gpsCoord[0], gpsCoord[1]);
            });
        }

    }

    private positionChanged(lon: any, lat: any): void {
        this.onEdit({lon: lon, lat: lat});
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-geoadmin-map/dv-geoadmin-map.ts